import { useEffect } from "react";
import { getCareers } from "../store/slices/careersSlice";
import { useDispatch, useSelector } from "react-redux";

export const useCareers = () => {
  const dispatch = useDispatch();

  const careersData = useSelector((state) => state.careers);

  useEffect(() => {
    if (careersData.status === "idle") {
      careerData();
    }
  }, []);

  const careerData = async () => {
    await dispatch(getCareers({ slug: "careers" }));
  };
};
